import { apiRegister } from '../../common/api'
import { ERR_REQ_UID, NO_ERROR, ERR_REP_USER_INFO } from '../../const'
import { isOkId, isPlain } from '../../utils/base'

import { KUser } from '../../models/k-user'

// 977	xsh/course	/xsh/course/teacher/detail/	老师细节查询
export const teacherDetail = apiRegister('teacherDetail', {
  protoId: 977,
  path: '/xsh/course/teacher/detail/',
  checkQuery(Q) {
    if (!isOkId(Q.uid)) {
      return ERR_REQ_UID
    }
    return NO_ERROR
  },
  checkResult({ userInfosMap }) {
    if (!isPlain(userInfosMap)) {
      return ERR_REP_USER_INFO
    }
    return NO_ERROR
  },
  formatResult(R, { uid }) {
    const { userInfosMap } = R
    const userInfo = userInfosMap[uid]
    R.userInfo = KUser(userInfo)
  }
}).send

// 	979	xsh/course	/xsh/course/teacher/courses/	老师教授的课程
export const teacherCourses = apiRegister('teacherCourses', {
  protoId: 979,
  path: '/xsh/course/teacher/courses/',
  checkQuery(Q) {
    if (!isOkId(Q.uid)) {
      return ERR_REQ_UID
    }
    return NO_ERROR
  }
}).send

// 976	xsh/course	/xsh/course/teacher/orders/	老师出售的课程订单列表（学生购买）
export const teacherOrders = apiRegister('teacherOrders', {
  protoId: 976,
  path: '/xsh/course/teacher/orders/'
  // checkQuery(Q) {
  //   // if(!isOkId(Q.uid)) {
  //   //   return ERR_REQ_UID
  //   // }
  //   return NO_ERROR
  // }
}).send

// 	975	xsh/course	/xsh/course/student/orders/	学生购买订单列表(我的订单)
export const studentOrdersLoad = apiRegister('studentOrdersLoad', {
  protoId: 975,
  path: '/xsh/course/student/orders/'
  //   checkQuery(Q) {
  //     if(!isOkId(Q.uid)) {
  //       return ERR_REQ_UID
  //     }
  //     return NO_ERROR
  //   }
}).send

// 	978	xsh/course	/xsh/course/reward/list/	老师的返现列表
export const myIncomesLoad = apiRegister('myIncomesLoad', {
  protoId: 978,
  path: '/xsh/course/reward/list/',
  //   checkQuery(Q) {
  //     if(!isOkId(Q.uid)) {
  //       return ERR_REQ_UID
  //     }
  //     return NO_ERROR
  //   },
  formatResult(R) {
    return R
  }
}).send
